import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Clock3, X } from "lucide-react";
import { formatDurationLabel, formatCoolingRemaining } from "../utils/sessionCoolingHelpers";
import { dismissCoolingWarning, tickSessionRemaining } from "../redux/sessionCoolingSlice";
import { selectAppIsAuthenticated } from "../redux/appAuthSlice";
import "../session-cooling.css";

function formatRemainingLabel(ms) {
  if (!ms || ms <= 0) return "soon";
  if (ms <= 5 * 60 * 1000) return formatCoolingRemaining(ms);
  return formatDurationLabel(ms) || "soon";
}

export default function SessionCoolingWarningBanner() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectAppIsAuthenticated);
  const { warningVisible, sessionRemainingMs, coolingDurationMs } = useSelector(
    (s) => s.sessionCooling
  );

  useEffect(() => {
    if (!warningVisible) return undefined;
    const timer = window.setInterval(() => {
      dispatch(tickSessionRemaining());
    }, 1000);
    return () => window.clearInterval(timer);
  }, [warningVisible, dispatch]);

  if (!isAuthenticated || !warningVisible) return null;

  const remainingLabel = formatRemainingLabel(sessionRemainingMs);
  const breakLabel = formatDurationLabel(coolingDurationMs) || "30 minutes";

  return (
    <>
      <div className="session-cooling-warning-scrim" aria-hidden />
      <div className="session-cooling-warning" role="alert">
        <div className="session-cooling-warning-icon" aria-hidden>
          <Clock3 size={22} />
        </div>
        <div className="session-cooling-warning-copy">
          <p className="session-cooling-warning-kicker">Break starting soon</p>
          <p className="session-cooling-warning-timer">{remainingLabel}</p>
          <p className="session-cooling-warning-body">
            Your session limit is almost reached. A {breakLabel} break will start automatically.
          </p>
        </div>
        <button
          type="button"
          className="session-cooling-warning-dismiss"
          onClick={() => dispatch(dismissCoolingWarning())}
          aria-label="Dismiss break reminder"
        >
          <X size={18} aria-hidden />
        </button>
      </div>
    </>
  );
}
